// extracted by mini-css-extract-plugin
export default {"page":"page___Cysru","logo":"logo___hUCN8","content":"content___sA1NJ","title":"title___hXa3C","subtitle":"subtitle___P_7Ah","btn":"btn___qMtM4","footer_glow":"footer_glow___dt9uN"};